'use strict';
require('jquery');

/**
 * Initialises the location search widget.
 *
 * options.locations  — array of {code, institution, country}
 * options.onSelect   — callback(code, label) called when the user selects a result
 */
module.exports = function initLocationSearch({ locations, onSelect }) {
  const $search  = $('#location-search');
  const $results = $('#location-results');
  const $status  = $('#location-search-status');

  let matches = [];
  let activeIndex = -1;

  function optionId(code) {
    return `location-opt-${code}`;
  }

  function setActive(index) {
    $results.children().removeClass('is-active').attr('aria-selected', 'false');
    activeIndex = index;
    if (index < 0 || index >= matches.length) {
      $search.removeAttr('aria-activedescendant');
      return;
    }
    const $li = $results.children().eq(index);
    $li.addClass('is-active').attr('aria-selected', 'true');
    $search.attr('aria-activedescendant', $li.attr('id'));
    const el = $li.get(0);
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  function closeResults() {
    $results.prop('hidden', true);
    $search.attr('aria-expanded', 'false');
    setActive(-1);
  }

  function showResults(list) {
    matches = list;
    $results.empty();
    if (!matches.length) {
      $results.prop('hidden', true);
      $search.attr('aria-expanded', 'false');
      $search.removeAttr('aria-activedescendant');
      $status.text($search.val() ? 'No results found' : '');
      return;
    }
    $status.text('');
    matches.forEach(loc => {
      $('<li>').text(`${loc.institution}, ${loc.country}`)
               .attr({ id: optionId(loc.code), role: 'option', 'aria-selected': 'false' })
               .data('code', loc.code)
               .appendTo($results);
    });
    $results.prop('hidden', false);
    $search.attr('aria-expanded', 'true');
    setActive(-1);
  }

  function selectOption($li) {
    onSelect($li.data('code'), $li.text());
    closeResults();
  }

  $search.on('input', function () {
    const q = $(this).val().toLowerCase();
    if (!q) { closeResults(); $status.text(''); return; }
    showResults(locations.filter(l =>
      l.institution.toLowerCase().includes(q) || l.country.toLowerCase().includes(q)
    ));
  });

  $search.on('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if ($results.prop('hidden')) {
        if (matches.length) showResults(matches);
        return;
      }
      if (!matches.length) return;
      const next = e.key === 'ArrowDown'
        ? (activeIndex + 1) % matches.length
        : (activeIndex - 1 + matches.length) % matches.length;
      setActive(next);
    } else if (e.key === 'Enter') {
      if (!$results.prop('hidden') && activeIndex > -1) {
        e.preventDefault();
        selectOption($results.children().eq(activeIndex));
      }
    } else if (e.key === 'Escape') {
      if (!$results.prop('hidden')) {
        e.preventDefault();
        closeResults();
      }
    }
  });

  $results.on('click', 'li', function () {
    selectOption($(this));
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.location-search-wrapper').length) {
      closeResults();
    }
  });
};
